import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Firebase/Firebase"; // Ajusta si es necesario

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./MarcasCarrusel.css"; // opcional si usas CSS personalizado
import LoadingScreen from "../loading";
import { useNavigate } from "react-router-dom";

const MarcasCarrusel = () => {
  const [marcas, setMarcas] = useState([]);

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const snapshot = await getDocs(collection(db, "marca"));
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMarcas(data);
      } catch (error) {
        console.error("Error al obtener marcas:", error);
      }
    };

    fetchMarcas();
  }, []);

  const navigate = useNavigate();

  const handleMarcaClick = (marcaId) => {
    navigate(`/marca/${marcaId}`);
  };

  return (
    <div className="marcas-carrusel-container">
      {marcas.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 3500 }}
          loop={true}
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          className="swiper-marcas"
        >
          {marcas.map((marca) => (
            <SwiperSlide key={marca.id} className="marca-slide" onClick={() => handleMarcaClick(marca.id)}>
              <div className="marca-content">
                <img src={marca.logo} alt={marca.nombre} className="marca-logo" />
                <button className="visitar-btn">Visitar</button>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <LoadingScreen />
      )}
    </div>
  );
};

export default MarcasCarrusel;
